import { useAuth0 } from "@auth0/auth0-react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from '@material-ui/core';
import Dialog from "@material-ui/core/Dialog";
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PrintIcon from "@mui/icons-material/Print";
import Paper from '@mui/material/Paper';
import PreSchoolService from "Lib/API/PreSchool";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog/index";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import SendLetter from "components/SendLetter/SendLetter";
import SuccessModal from "components/SuccessModal/SuccessModal";
import ClearGroupFilter from "components/clearGroupFilter";
import RightDrawer from 'components/drawer';
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { useReactToPrint } from "react-to-print";
import { displayProductsHandler, getFormDataHandler } from "utils/formDataHelper";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import ParticipantDetailsTableBody from './ParticipantDetailsTableBody';
import ParticipantDrawer from './ParticipantDrawer/ParticipantDrawer';
import { ButtonContainer } from './Theme';
import FinanceDrawer from "pages/NewFinance/Drawer";
import ChargeLoader from "pages/Forms/membersDetails/ParticipantDetailsTable/ChargeLoader";
import { useFetchData } from "hook/useFetchData";
import FinanceService from "Lib/API/Finance/index";
import ViewDocumentModal from "pages/NewFinance/Documents/ViewDocumentModal"
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal/index";
import { formatDate } from "helper/dateFormat";
const ParticipantDetailsTable = ({ getClassParticipants, sorting, setSorting
  , participantsPage, setParticipantsPage, count, rows,
   loading,onSharePaymentLinkClick,handleInputChange,searchValue,eventId,participantGroupId,isMultiEvent,eventDates,multiEventsType,isFreeEvent }) => {

     const [openShareModal, setOpenShareModal] = React.useState(false);
  const [documentRow, setDocumentRow] = React.useState(null);
   const [chargeModal, setChargeModal] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [check, setCheck] = useState([]);
  const [checkAll,setCheckAll] = useState(false)
  const styleButtons = {color: '#454758',fontSize:'14px',fontWeight: '400'}
  const [csvData, setExportData] = React.useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [exportType, setExportType] = useState("");
  const [updateData,setUpdateData]=useState(false)
  const [openLetterModal, setOpenLetterModal] =useState(false);
  const [openSuccessModal, setOpenSuccessModal] =useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const {
    data: chargeData,
    loading: chargeLoading,
    fetchData,
  } = useFetchData(FinanceService.getAllTransactionsEnhance);
  const [viewDocumentContent, setViewDocumentContent] = useState(null);
  const [viewDocumentId, setViewDocumentId] = useState(null);
  const componentRef = useRef();


  const closeModalCharge = () => setChargeModal(false);
   const openModalCharge = (data) => {
    fetchData(1, 30, {
      search: data,
      filter: {
        hidden: true,
      },
    });
    setChargeModal(true);
  };

    const viewDocumentHandler = (documentId) => {
    setViewDocumentId(documentId);
  }

  const viewLetterHandler = (documentContent) => {
    setViewDocumentContent(documentContent);
  }


  const downloadFileHandler = async (row) => {
    const { _id, name, type } = row;
    const token = await getAccessTokenSilently();
    await FinanceService.downloadDocument(token, _id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const currentDate = formatDate({ date: new Date(), formatType: "defaultWithUTC" });
      const fileType = type === "tax_statement" ? "Statement" : type.charAt(0).toUpperCase() + type.slice(1);
      const fileName = `${fileType}_${name.replaceAll(" ", "_")}_${currentDate}`
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }


  const documentHandler = (row) => {
    setOpenShareModal(true);
    setDocumentRow(row);
  }

  const getExportFileName = () => {
    return check?.[0]?.event?.eventName ? `${check?.[0]?.event?.eventName}.xlsx` : `Participants.xlsx`
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: getExportFileName(),
  });
  const HeaderTitles = [
    {
      label: 'FIRST NAME',
      value: 'firstName',
      sortable: true,
    },
    {
      label: 'LAST NAME',
      value: 'lastName',
      sortable: true,
    },
    {
      label: 'PHONE NUMBER',
      value: 'phone',
      sortable: false,
    },
    {
      label: !isFreeEvent ? 'STATUS' : '',
      value: 'registrationStatus',
      sortable: false,
    },
    {
      label: !isFreeEvent ? 'TOTAL PAID' : '',
      value: 'totalPaid',
      sortable: true,
    },
    ...(!isMultiEvent ? [{
      label: 'EVENT ATTENDED',
      value: 'attended',
      sortable: false,
    }] : []),
  ];
  const columns_for_header = [
    {
      id: "groupId",
      displayName: "#",
      headerName: "#",
      field: "groupId",
      flex: 1,
    },
    {
      id: "firstName",
      displayName: "First Name",
      headerName: "First Name",
      field: "firstName",
      flex: 1,
    },
    {
      id: "lastName",
      displayName: "Last Name",
      headerName: "Last Name",
      field: "lastName",
      flex: 1,
    },
    {
      id: "phone",
      displayName: "Phone Number",
      headerName: "Phone Number",
      field: "phone",
      flex: 1,
    },
    {
      id: "paymentStatus",
      displayName: "Status",
      headerName: "Status",
      field: "paymentStatus",
      flex: 1,
    },
    {
      id: "total",
      displayName: "Total Paid",
      headerName: "Total Paid",
      field: "total",
      flex: 1,
    },
  ];

  const handleSortChange = (name) => {
    setSorting((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      }
    }));
  };
  const onCheckboxChange = (e, row) => {
    setCheckAll(false)
    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    }
    setCheck((prev) => [
      ...prev,
        row
      
    ]);
  };

  const onCheckboxAllChange = (e) => {
    const items = rows
    setCheckAll(e.target.checked)
    if(!e.target.checked){
      return setCheck([]);
    }
    const allChecked = [...check, ...items].filter(
      (item, index, self) => index === self.findIndex((i) => i._id === item._id)
    );
    setCheck(allChecked);
  };

  useEffect(() => {
    if (participantGroupId) {
      getClassParticipants(1);
      setParticipantsPage(1);
    } else {
      getClassParticipants();
    }
  }, [refresh,updateData, sorting,participantGroupId]);



  const getMultiDateExportFields = (item, dates, isGrouped) => {
    if (!dates?.length) return {};
    return dates.reduce((acc, dateEntry) => {
      const dateStr = dateEntry.eventDate
        ? formatDate({ date: dateEntry.eventDate, formatType: 'defaultWithTime' })
        : '';
      const label = [dateEntry.label, dateStr].filter(Boolean).join(' - ');
      const participantDate = item?.eventsDates?.find(d => d.name === dateEntry.name || d.label === dateEntry.label);
      acc[`Registered to ${label}`] = isGrouped ? 'Yes' : (participantDate ? 'Yes' : 'No');
      acc[`Attended to ${label}`] = participantDate?.attended ? 'Yes' : 'No';
      return acc;
    }, {});
  };

  const excelSheet = () => {
    const arr = [];
    const isGrouped = multiEventsType === 'grouped';
    if (csvData?.length > 0) {
      csvData.map((item) => {
          const data = {
            ["#"]: item?.groupId?.toString(),
            ["First Name"]: item?.firstName,
            ["Last Name"]: item?.lastName,
            ["Phone Number"]: item?.phone || "-",
            ["Status"]: item?.registrationStatus,
            ["Total Paid"]:`${numberFormat({number:item?.payment?.register?.totalPaid,decimal:2, style:'currency'})}`,
            ...getFormDataHandler(item?.event?.form?.task_data,item?.formData),
            ["Ticket Type"]: item?.ticket?.title || "",
            ...displayProductsHandler(item?.products),
            ...(isMultiEvent ? getMultiDateExportFields(item, eventDates, isGrouped) : {}),
          };
          arr.push(data);
        });
    }
    return arr;
  };
  const generateExcel = () => {
    let res = excelSheet()
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      getExportFileName()
    );
  };

  const downloadExcel = () => {
    getExportData("excel")
  };
  const getExportData = async (value) => {
    const token = await getAccessTokenSilently();
    const ides =checkAll ?[]:check.map(item=>{
      return item._id
    });
    const body = {eventId:eventId,participantsIds:ides}
    PreSchoolService.exportParticipant(token, body)
      .then((res) => {
        setExportData(res?.payload?.data);
        checkAll && setCheck(res?.payload?.data)
        setExportType(value);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if(!exportType) return;
    if (exportType == "print") {
      handlePrint();
    } else if (exportType == "excel") {
      generateExcel();
    }
    setExportType("");
  }, [exportType]);
  let customCsvData = []
  let myData =
    csvData?.length !== 0
      && csvData?.map((item) => {
          // return item?.map((li) => {
            const data = {
              groupId: item?.groupId,
              firstName: item?.firstName,
              lastName: item?.lastName,
              phone: item?.phone || "-",
              paymentStatus: item?.registrationStatus,
              total:`${numberFormat({number:item?.payment?.register?.totalPaid,decimal:2, style:'currency'})}`,

            };
            customCsvData.push(data);
          // });
        })


    
  
  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      participantsIds: checkAll ? undefined :check.map((item) => item._id),
      eventsIds: checkAll ? [eventId] : undefined,
     ...templateData
    }

    PreSchoolService.sendEventParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      }).finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };



  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenDrawer(false);
  }

 
  return (
    <div className="w-100">
      <div className={'family-table-container pl-7 pr-6 pt-3 pb-22'}>
        <div
            style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "18px",
                justifyContent:'space-between'
              }}
              className="header__options"
            >
              <div className="d-flex align-items-center" style={{
                gap: "15px"
              }}>
                <span className="finance-filter-serach-bar ml-5">
                  <SearchComp
                    value={searchValue}
                    setSearchText={handleInputChange}
                    placeholder="Search"
                    style={{ width: "20.5rem", backgroundColor: "#fff" }}
                  />
                </span>
                {participantGroupId && (
                  <ClearGroupFilter text="Filtered By Group"/>
                )}
              </div>
            {check?.length > 0 &&
              <div className="new-class mt-4">
              <MyButton
                type="secondary"
                content={
                  <ButtonContainer>
                    <FileDownloadIcon style={{ height: "20px" }} />
                    <a
                      style={styleButtons}
                    >
                      Export
                    </a>
                  </ButtonContainer>
                }
                style={{
                  background: "#F4F6F9",
                  color: "#2555EF",
                  border: "none",
                  marginRight: "1rem",
                }}
                onClick={downloadExcel}
                />
            <MyButton
                    type="secondary"
                    onClick={() => getExportData("print")}
                    content={
                      <ButtonContainer>
                        <PrintIcon style={{ height: "20px" }} />
                        <a
                          style={styleButtons}
                        >
                          Print
                        </a>
                      </ButtonContainer>
                    }
                    style={{
                      background: "#F4F6F9",
                      color: "#2555EF",
                      border: "none",
                      marginRight: "1rem",
                    }}
                  />
                  <span className="button-line" />
                  <MyButton
                    onClick={() => setOpenLetterModal(true)}
                    type="secondary"
                    content={
                      <ButtonContainer>
                        <ForwardToInboxIcon style={{ height: "20px" }} />
                        Send Letter: {checkAll ? count : check.length}
                      </ButtonContainer>
                    }
                    style={{
                      background: "#D3DDFC",
                      color: "#2555EF",
                      border: "none",
                      marginRight: "1rem",
                      padding: "0px 25px",
                    }}
                  />
                  {/* <span className="button-line" /> */}
                  {/* <MyButton
                    type="secondary"
                    content={
                      <ButtonContainer>
                        <ShareIcon style={{ height: "20px" }} />
                        Share Payment Link
                      </ButtonContainer>
                    }
                    style={{
                      background: "#D3DDFC",
                      color: "#2555EF",
                      border: "none",
                      marginRight: "1rem",
                      padding: "0px 25px",
                    }}
                    onClick={() => {
                      onSharePaymentLinkMultipleClick(check);
                    }}
                  /> */}
              </div>
            }
        </div>
            
        <div className="home-table-container mt-0 no-box-shadow">
          <TableContainer component={Paper} className="scroll-table">
            <Table class="main-table" aria-label="collapsible table">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                <TableCell className="charged-value-check-box" align="left">
                    <CheckBox
                      onChange={(e) => {
                        onCheckboxAllChange(e);
                      }}
                      text={""}
                      checked={checkAll}
                    />
                  </TableCell>
                  {isMultiEvent && <TableCell className="charged-value-check-box" align="left" />}
                  <TableCell className="charged-value-check-box" align="left">
                    #
                  </TableCell>
                  {HeaderTitles.filter(Item => Item?.label !== '').map((Item) => (
                    <TableCell className="charged-value" align="left">
                      {Item?.label}
                      {Item?.sortable && (
                        <IconButton  onClick={() => handleSortChange(Item?.value)}>
                          <SortIcon/>
                        </IconButton>
                      )}
                    </TableCell>
                  ))}
                  <TableCell className="empty-head sticky-header-column" align="right" />
                </TableRow>
              </TableHead>
              <TableBody className="tran-table-body">
                <ParticipantDetailsTableBody
                  rows={rows}
                  setOpenDrawer={setOpenDrawer}
                  setDrawerData={setDrawerData}
                  loading={loading}
                  classId={eventId}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  onSharePaymentLinkClick={onSharePaymentLinkClick}
                  onCheckboxChange={onCheckboxChange}
                  check={check}
                  checkAll={checkAll}
                  isMultiEvent={isMultiEvent}
                  eventDates={eventDates}
                  isFreeEvent={isFreeEvent}
                />
              </TableBody>
            </Table>
          </TableContainer>
            <div className="pagination-custom mt-20">
              <Pagination
                count={Math.ceil(count / 30)}
                color="primary"
                variant="outlined"
                page={participantsPage}
                onChange={(event, value) => {
                  setParticipantsPage(value);
                  getClassParticipants(value);
                }}
              />
            </div>
          <div className="d-none">
          <div id="componentRef" ref={componentRef}>
            <table style={{ padding: 10, margin: 10}}>
              <thead>
                {columns_for_header?.map((column, index) => (
                  <th
                    style={{ border: "1px solid", textAlign: "center" }}
                    key={index}
                  >
                    {column?.headerName}
                  </th>
                ))}
              </thead>
              <tbody>
                {customCsvData?.map((item, index) => {
                  const d = {
                    ["#"]: item?.groupId,
                    ["First Name"]: item?.firstName,
                    ["Last Name"]: item?.lastName,
                    ["Phone Number"]: item?.phone,
                    ["Status"]: item?.paymentStatus,
                    ["Total Paid"]:item?.total,
                  };
                  return (
                    <tr key={index}>
                      {Object?.values(d)?.map((objectValue, index) => (
                        <td
                          style={{
                            border: "1px solid",
                            padding: 5,
                          }}
                          key={index}
                        >
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        </div>
        <RightDrawer
          open={openDrawer}
          onClose={closeModal}
        >
          <ParticipantDrawer
            drawerData={drawerData}
            closeModal={() => {
              setOpenDrawer(false);
            }}
                 openModalCharge={openModalCharge}
            closeModalCharge={closeModalCharge}
            onSharePaymentLinkClick={onSharePaymentLinkClick}
            getClassParticipants={getClassParticipants}
            updateData={updateData}
          />
        </RightDrawer>

            <RightDrawer open={!!chargeModal} onClose={closeModalCharge}>
          <div className="finance-drawer">
            {chargeLoading ? (
              <ChargeLoader />
            ) : (
              <FinanceDrawer
                data={chargeData?.payload?.data?.[0] ?? {}}
                onReversalClick={() => {}}
                viewDocumentHandler={viewDocumentHandler}
                downloadFileHandler={downloadFileHandler}
                documentHandler={documentHandler}
                viewLetterHandler={viewLetterHandler}
                hideActions
                onPaymentSuccess={() => {
                  setUpdateData(prev => !prev);
                  getClassParticipants();
                }}
              />
            )}
          </div>

        </RightDrawer>
        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
            setCheck([]);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter 
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            initialEmails={check?.length && check.map(item=>item?.email)} 
            isMultiple={check?.length > 1} 
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="event"
          />
        </Dialog>
         <Dialog
                open={viewDocumentId !== null || viewDocumentContent !== null}
                onClose={() => {
                  setViewDocumentId(null);
                  setViewDocumentContent(null);
                }}
                PaperProps={{
                  style: {
                    width: "888px",
                    height: "90vh",
                    overflow: "hidden",
                    borderRadius: "22px",
                  },
                }}
                fullWidth
                maxWidth={"md"}
              > 
                <ViewDocumentModal
                  documentHtmlContent={viewDocumentContent ? viewDocumentContent : null}
                  documentId={viewDocumentId ? viewDocumentId : null}
                  closeModal={() => {
                    setViewDocumentId(null);
                    setViewDocumentContent(null);
                  }}
                />
              </Dialog>
                  <Dialog
                      open={openShareModal}
                      onClose={() => {
                        setOpenShareModal(false);
                      }}
                      PaperProps={{
                        style: {
                          width: "888px",
                          height: "637px",
                          overflowX: "hidden",
                          borderRadius: "22px",
                        },
                      }}
                      fullWidth
                      maxWidth={"md"}
                    >
                      <ShareDocumentsModal
                        closeModal={() => {
                          setOpenShareModal(false);
                        }}
                        documentsIds={[documentRow?._id]}
                        documentType={documentRow?.type}
                        defaultEmail={documentRow?.account_details?.defaultEmails || []}
                        type="Document"
                      />
                    </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal 
            title="Successfully Sent"
            description={`The total number of recipients is ${check.length}`}
            btnText="Done"
            btnAction={ () => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </div>
  );
};

export default ParticipantDetailsTable;
